const sortJournalRecords = <T extends { createdAt?: Date; id: string }>(records: T[]): T[] =>
  records.sort((recordA, recordB) => {
    const dateComparison = new Date(recordA.createdAt ?? 0).getTime() - new Date(recordB.createdAt ?? 0).getTime()

    if (dateComparison !== 0) {
      return dateComparison
    }

    return recordA.id.localeCompare(recordB.id)
  })

export default sortJournalRecords
